import React from 'react';
import VisualClockPicker from './VisualClockPicker';

const TimePickerField = ({ value, onChange, inputClass, placeholder }) => {
  return (
    <VisualClockPicker
      value={value}
      onChange={onChange}
      inputClass={inputClass}
      placeholder={placeholder}
    />
  );
};

export default TimePickerField;
